import { reactive } from 'vue'
import { api, setCsrf } from './api'
import { setLocale } from './i18n'

export const session = reactive({ user: null, ready: false })
export const experience = reactive({ sound_enabled: true, effects_level: 'gentle', story_autoplay: true, ready: false })

export async function loadSession() {
  try {
    const data = await api('/api/auth/me')
    session.user = data.user
    setLocale(data.user.learning_language || 'zh-CN')
    setCsrf(data.csrf_token)
  } catch {
    session.user = null
    setCsrf('')
  } finally {
    session.ready = true
  }
}

export function acceptSession(data) {
  session.user = data.user
  setLocale(data.user.learning_language || 'zh-CN')
  setCsrf(data.csrf_token)
}

export async function loadExperience() {
  if (!session.user?.onboarding_complete) return
  if (experience.ready) return
  try {
    const data = await api('/api/settings/experience')
    Object.assign(experience, data.experience, { ready: true })
  } catch {
    experience.ready = true
  }
}

export function setExperience(value) {
  Object.assign(experience, value, { ready: true })
}

export function clearSession() {
  session.user = null
  setCsrf('')
  experience.ready = false
}
